import React from "react";

/** AC-3 bitstream inspector — dialnorm / bitrate / channel-mode readout. */
export default function Ac3InspectorPanel({ inspect, inspecting, inspectBitstream }) {
  return (
    <>
          {/* AC-3 bitstream inspector */}
          <div className="border-t border-zinc-800 pt-4" data-testid="bitstream-inspect-section">
            <div className="flex items-baseline justify-between mb-2">
              <div className="font-display font-bold">AC-3 bitstream inspector</div>
              <button
                onClick={inspectBitstream}
                disabled={inspecting}
                data-testid="bitstream-inspect-btn"
                className="font-mono text-[10px] uppercase tracking-widest px-3 py-1 rounded-sm border border-emerald-500/60 text-emerald-400 hover:bg-emerald-500/10 disabled:opacity-40"
              >
                {inspecting ? "Reading…" : "Inspect bitstream"}
              </button>
            </div>
            {inspect ? (
              <div className="border border-zinc-800 rounded-sm bg-black/40 p-3 font-mono text-[11px] space-y-1" data-testid="bitstream-inspect-result">
                <div className="grid grid-cols-2 gap-x-4 gap-y-0.5">
                  <div>syncword <span className="text-emerald-400">{inspect.bitstream.syncword}</span></div>
                  <div>bsid <span className="text-emerald-400">{inspect.bitstream.bsid}</span></div>
                  <div>acmod <span className="text-emerald-400">{inspect.bitstream.acmod}</span> ({inspect.bitstream.acmod_label})</div>
                  <div>lfeon <span className="text-emerald-400">{String(inspect.bitstream.lfeon)}</span></div>
                  <div>dialnorm <span className="text-emerald-400">{inspect.bitstream.dialnorm_label}</span></div>
                  <div>bsmod <span className="text-emerald-400">{inspect.bitstream.bsmod}</span></div>
                  <div>mixlevel <span className="text-emerald-400">{inspect.bitstream.mixlevel_db} dB</span></div>
                  <div>roomtyp <span className="text-emerald-400">{inspect.bitstream.roomtyp_label}</span></div>
                  <div>dsurmod <span className="text-emerald-400">{inspect.bitstream.dsurmod_label}</span></div>
                  <div>compre <span className="text-emerald-400">{inspect.bitstream.compre_profile}</span></div>
                  <div>dynrng <span className="text-emerald-400">{inspect.bitstream.dynrng_profile}</span></div>
                  <div>sample rate <span className="text-emerald-400">{inspect.bitstream.sample_rate_hz / 1000} kHz</span></div>
                  <div>frame <span className="text-emerald-400">{inspect.bitstream.frame_size_bytes} B / {inspect.bitstream.frame_size_samples} spl</span></div>
                  <div>bitrate <span className="text-emerald-400">{inspect.bitstream.bitrate_kbps} kbps</span></div>
                </div>
                <div className="pt-2 mt-1 border-t border-zinc-800 text-zinc-400">
                  downmix{" "}
                  <span className="text-emerald-400">{inspect.bitstream.downmix.mode}</span>
                  {" · "}
                  <span className="text-zinc-300">{inspect.bitstream.downmix.embedded ? "embedded" : "separate"}</span>
                  {" · center "}<span className="text-emerald-400">{inspect.bitstream.downmix.center_mix_db} dB</span>
                  {" · surround "}<span className="text-emerald-400">{inspect.bitstream.downmix.surround_mix_db} dB</span>
                </div>
              </div>
            ) : (
              <div className="text-xs text-zinc-500 italic">
                Click &quot;Inspect bitstream&quot; to read live AC-3 sync-frame metadata (bsid, acmod, lfeon, dialnorm, dsurmod, roomtyp…)
              </div>
            )}
          </div>
    </>
  );
}
